import React, { useState } from "react";

export default function SportMonoIcon(props: {
	sportAbrv: string;
	className?: string;
}) {
	const [imageError, setImageError] = useState<boolean>(false);

	const { className, sportAbrv } = props;

	if (!sportAbrv || imageError) {
		return null;
	}

	const style = className
		? className
		: "u-icon u-icon--sml u-icon--sport u-icon--sport--mono";

	const getSportMonoIcon = (sportAbrv: string) => {
		return `${WEBPACK_CDN_ROOT_URL}/icons/sport/${sportAbrv}/${sportAbrv}--mono.svg`;
	};

	return (
		<img
			src={getSportMonoIcon(sportAbrv)}
			//@ts-expect-error
			loading="lazy"
			onError={() => {
				setImageError(true);
			}}
			className={style}
			alt={`icon-${sportAbrv}`}
		/>
	);
}
